// Copyright (c) 2016 Deere & Company

import SearchResults from '../state/search-results';
import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updateSearchResults = (state, action) =>
    SearchResults.update(state, {
        $set: action.searchResults
    });

const actionTypes = {
    [actions.UPDATE_PART_REQUESTS_SEARCH_RESULTS]: updateSearchResults
};

export default (state = getDefaultState().searchResults, action) => {

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/part-requests/search/reducers/search-results.js